<div #divider class="tt-divider-row">
    <ng-content></ng-content>
</div>
